export var replaceDotWithComma = function replaceDotWithComma(restValue) {
  return String(restValue).replace('.', ',');
};
export var formatTimeUnit = function formatTimeUnit(unit) {
  var timeUnit = ['минута', 'минуты', 'минут'];
  if (timeUnit.includes(unit)) {
    return 'мин';
  }
  return unit;
};
export var composeUnit = function composeUnit(restValue, unit, isUnlimited) {
  return "".concat(isUnlimited ? '∞' : replaceDotWithComma(restValue), " ").concat(formatTimeUnit(unit));
};
export var getUnit = function getUnit(responseUnit) {
  if (responseUnit.toLocaleLowerCase() === 'sms') {
    return 'смс';
  }
  return responseUnit.toLocaleLowerCase();
};
export var composePriceTextVariant = function composePriceTextVariant(isLast, isMobile) {
  if (isLast) {
    return isMobile ? 'caption-medium' : 'body-paragraph-small';
  }
  return isMobile ? 'body-small' : 'body-medium';
};
export var composeValueTextVariant = function composeValueTextVariant(isLast, isMobile) {
  if (!isLast) {
    return 'caption-medium';
  }
  return isMobile ? 'caption-medium' : 'body-paragraph-small';
};